import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from '@mui/material';
import React, { ReactElement } from 'react';
import {
  Control,
  Controller,
  FieldValues,
  Path,
  RegisterOptions,
  UseFormReturn,
} from 'react-hook-form';

interface FormCheckBoxProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  fieldName: Path<T>;

  label?: string | number | ReactElement;
  labelPlacement?: "end" | "start" | "top" | "bottom";
  validation?: RegisterOptions;
  disabled?: boolean;
  fullWidth?: boolean;
}

export const FormCheckBox = <T extends FieldValues>(props: FormCheckBoxProps<T>): ReactElement | null => {
  const { form, label, labelPlacement = "end", fieldName, validation, disabled, fullWidth = true } = props;

  return (
    <Controller
      control={form.control as Control<FieldValues>}
      name={fieldName}
      rules={validation}
      render={({ field: { onChange, onBlur, value, name }, fieldState: { error } }) => (
        <FormControl component="fieldset" required={!!validation?.required} error={!!error} fullWidth={fullWidth}>
          <FormGroup>
            <FormControlLabel
              label={label || ""}
              labelPlacement={labelPlacement}
              control={
                <Checkbox
                  name={name}
                  checked={!!value}
                  onBlur={onBlur}
                  onChange={(event) => onChange(event.target.checked)}
                  disabled={disabled}
                />
              }
            />
          </FormGroup>

          {!!error && <FormHelperText error>{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};
